import httpClient from "../../../../shared/api/httpClient";
import { qs } from "../../../../shared/api/qs";

function getLicenseIdOrThrow() {
  try {
    const raw = localStorage.getItem("sabi_empresa_id");
    if (!raw) throw new Error();

    const licenseId = Number(raw);
    if (!Number.isFinite(licenseId) || licenseId <= 0) throw new Error();

    return licenseId;
  } catch {
    throw new Error("No se encontró sabi_empresa_id en localStorage.");
  }
}

const BASE = "/hr/areas/messaging";

export async function listarGruposAreaChat(params = {}) {
  const licenseId = getLicenseIdOrThrow();

  return httpClient.get(
    `${BASE}/licenses/${licenseId}/area-chats/groups${qs({
      q: params.q,
      branchId: params.branchId,
      areaId: params.areaId,
      page: params.page ?? 1,
      pageSize: params.pageSize ?? 200,
    })}`
  );
}

export async function listarMensajesGrupoArea(threadId, params = {}) {
  const licenseId = getLicenseIdOrThrow();

  return httpClient.get(
    `${BASE}/licenses/${licenseId}/area-chats/groups/${threadId}/messages${qs({
      page: params.page ?? 1,
      pageSize: params.pageSize ?? 100,
    })}`
  );
}

export async function enviarMensajeGrupoArea(threadId, payload) {
  const licenseId = getLicenseIdOrThrow();

  return httpClient.post(
    `${BASE}/licenses/${licenseId}/area-chats/groups/${threadId}/messages`,
    {
      contenido: payload?.contenido ?? payload?.content ?? "",
    }
  );
}